import React from "react"
import theme from "styles/theme"
import PropTypes from "prop-types"
import Icon from "components/atoms/Icon"

import { StyledResetButton } from "./ResetButton.styles"

const ResetButton = ({ onClickHandler }) => (
  <StyledResetButton type="button" onClick={onClickHandler} theme={theme}>
    <Icon icon="cursor" />
  </StyledResetButton>
)

ResetButton.propTypes = {
  onClickHandler: PropTypes.func.isRequired,
}
export default ResetButton
